<template lang="pug">
  v-col(cols="3" class="py-0")
    v-img(v-if="images.length > 0",
      :src="images[0]",
      aspect-ratio="1.7",
      width="165",
      height="166",
      style="border-radius:3px;")
    v-img(v-else,
      :src="require('@/assets/images/noimage.png')",
      aspect-ratio="1",
      width="165",
      height="166",
      style="border-radius:3px;")
</template>

<script>
export default {
  name: 'AdvertItemImage',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped></style>
